import {
    openReactActionDialog, ReactActionDialogBodyProps
} from '~commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { Set } from '~commonInfra/utils/Set';
import { SearchSuggestionsService } from '~src/spacesPlatform/services/SearchSuggestionsService';

import { Messages } from '../../../../codegen/Localize';
import { ListResult } from '../../../../httpClient/fetchers/ListResult';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import {
    AddUsersToGroupDialogBody, AddUsersToGroupDialogBodyProps, AddUsersToGroupDialogState
} from '../../../groups/components/AddUsersToGroupDialog';
import { SiteUsers } from '../../../services/resources/SiteUsers';
import { ISiteUserInfo } from '../../../users/models/ISiteUserInfo';
import { IGroupInfo } from '../../models/IGroupInfo';
import {
    GroupMembershipUpdateActionNotification
} from '../notifications/GroupMembershipUpdateActionNotification';

export type PropsForConfirmActionDialogBody = ReactActionDialogBodyProps<AddUsersToGroupDialogBodyProps, AddUsersToGroupDialogState>;

export namespace AddUsersToGroupAction {
  export function renderActionName(_: AddUsersToGroupDialogBodyProps, state: AddUsersToGroupDialogState): string {
    return Messages.confirmAddUsersToGroup({ADD_USER_COUNT_LOC: String(state.selectedUserIds.length)});
  }

  async function getInGroupSiteUserInfoList(group: IGroupInfo): Promise<ListResult<ISiteUserInfo>> {
    return SiteUsers.instance.getUsersByGroupIds([group.id]);
  }

  export async function showAddUsersToGroupDialog(group: IGroupInfo): Promise<IResult> {
    const usersInGroup = await getInGroupSiteUserInfoList(group);
    const dialogInstance = openReactActionDialog<AddUsersToGroupDialogBodyProps, AddUsersToGroupDialogState, IResult>({
      actionName: renderActionName,
      action: (_, state) => {
        const addUsersToGroupPromise = SiteUsers.instance.addToGroups(state.selectedUserIds, [group.id]).then(
          (result: any) => {
            // show toast
            GroupMembershipUpdateActionNotification.notify(
              result,
              state.selectedIUserInfoSet,
              1,
              group.name,
              0,
              ''
            );
            return result;
          }
        );
        return addUsersToGroupPromise;
      },
      actionDisabled: (_, state) => {return state.selectedUserIds.length === 0;},
      bodyComponent: AddUsersToGroupDialogBody,
      dialogWidth: TabDialogWidth.width700px,
      dismissDialogOnActionFailed: false,
      initialDialogState: {
        addableResultsList: [],
        selectedUserIds: [],
        selectedIUserInfoSet: new Set((item) => item.id)
      },
      initialBodyProps: {
        group,
        getQuery: SearchSuggestionsService.usersBySiteRoleAndSearch,
        inGroupUsersList: usersInGroup.items,
      },
      title: Messages.addUsers(),
    });

    return dialogInstance.result;
  }
}

export type AddUsersToGroupAction = typeof AddUsersToGroupAction;